import styled from 'styled-components';
import { Format, StyleColor } from '../../../utils/styles-constants';

export const StyledSliderContainer = styled('div')`
	padding: 40px;
	background: ${StyleColor.Black};
	height: calc( 100% - 45px - 64px );/* 100% - header.height - footer.height */
	box-sizing: border-box;

	.slick-slider,
	.slick-list,
	.slick-track,
	.slick-slide > div {
		height: 100%;
	}

	@media ${Format.Smartphone} {
		padding: 15px 30px;
	}
`;

export const SvgArrow = styled('svg')`
	opacity: 0.75;
	pointer-events: all;
	fill: ${StyleColor.White};

	&.slick-disabled{
		opacity: 0.25;
	}

	&:not(.slick-disabled):hover {
		opacity: 1;
	}
`;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Theater/Slider/styles.ts